import {GetterTree} from 'vuex';
import {appointment, mainRootState, rootStore, user, userObject} from "@/store/types";

export type Getters = {
    authenticated(state: userObject): boolean;
    getUserData(state: userObject): userObject;
    getUserAppointments(state: userObject): appointment[];
    getUserToken(state: userObject): string;
    getUserList(state: userObject): user[];
    getUser(state: userObject): (id: number) => user;
}

export const getters: GetterTree<userObject, rootStore> & Getters = {
    authenticated: (state) => {
        return state.authenticated;
    },
    getUserData(state): userObject {
        return {
            name: state.name,
            surname: state.surname,
            address: state.address,
            authenticated: state.authenticated,
            appointments: [],
            relatives: [],
            token: state.token
        };
    },
    getUserAppointments(state): appointment[] {
        return state.appointments;
    },
    getUserToken(state: userObject): string {
        return state.token;
    },
    getUserList(state: userObject): user[] {
        return state.relatives;
    },
    getUser(state: userObject): (id: number) => user {
        return (id) => {
            return state.relatives[id];
        }
    }
};
